import React from 'react';
import { Button } from 'tuui';
import { FORM_MODES } from 'config/formModes';
import { useNavigate } from 'hooks';
import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { LANDING_PAGE_CREATOR_ROUTE_PATH } from '../../config';
import { generateFormPath } from '../../utils/generateFormPath';

export const CreateLandingPageButton = () => {
    const { accountId } = useAccount();
    const navigate = useNavigate();

    const clickHandler = () => {
        navigate(
            generateFormPath({
                accountId,
                mode: FORM_MODES.CREATE,
                basePath: LANDING_PAGE_CREATOR_ROUTE_PATH,
            })
        );
    };

    return (
        <Button onClick={clickHandler}>
            <FormattedMessage id="landing.pages.create.button" defaultMessage="+ Create Advertorial" />
        </Button>
    );
};
